import LoadingContent from "../../public/LoadingContent.js";
import React, { useEffect, useState } from "react";
import SidebarNav from "../Sidebar/SidebarNav.js";
import pagesService from "../../../services/pagesService.js";
import ModalPage from "./ModalPages.js";

const Pages = () => {
    const titleSingular = 'Página';
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [editingModal, setEditingModal] = useState(null);

    const loadingContent = () => {
        pagesService.getPages().then(data => {
            setData(data);
            setLoading(false);
        });
    };

    const handleCreate = () => {
        setEditingModal(null);
        setModalOpen(true);
    };

    const handleEdit = (data) => {
        setEditingModal(data);
        setModalOpen(true);
    };

    const handleDelete = async (itemId) => {
        if (window.confirm("¿Estás seguro que deseas borrar esta página?")) {
            try {
                await pagesService.deletePage(itemId);
                loadingContent();
            } catch (error) {
                console.error("Error deleting page:", error);
            }
        }
    };

    useEffect(() => {
        loadingContent();
    }, []);

    return (
        <div className="container-fluid" style={{background: 'url(/waves-white.png)'}}>
            <div className="row vh-100">
                <SidebarNav />

                {isModalOpen && (
                    <ModalPage
                        editingModal={editingModal}
                        titleSingular={titleSingular}
                        isModalOpen={isModalOpen}
                        onClose={() => {
                            setModalOpen(false);
                            loadingContent();
                        }}
                    />
                )}

                <div className="p-4 content-container col-md-9 col-lg-10">
                    {loading && <LoadingContent />}
                    {!loading && (
                        <div>
                            <h3 className="mb-4"> <i className="bi bi-card-heading"></i>  Páginas Personalizadas</h3>
                            <button className="btn btn-primary mb-3" onClick={handleCreate}>
                                Crear Página
                            </button>

                            <table className="table table-striped corner-radius">
                                <thead>
                                <tr>
                                    <th>Título</th>
                                    <th>Contenido</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {Array.isArray(data) && data.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.title}</td>
                                        <td>{item.content.substring(0, 80)}...</td>
                                        <td>
                                            <div className="btn-group" role="group">
                                                <a
                                                    href={`/page/${item.id}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-info btn-sm"
                                                >
                                                    Ver
                                                </a>
                                                <button className="btn btn-warning btn-sm" onClick={() => handleEdit(item)}>Editar</button>
                                                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(item.id)}>Borrar</button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Pages;
